// Mock data for L'Original restaurant

export const restaurantInfo = {
  name: "L'Original",
  tagline: "Pizzas, Burgers, Sandwiches, Tex-Mex – Fresh, fast, tasty.",
  location: "Palaiseau",
  address: "40 Rue de Paris, 91120 Palaiseau, France",
  phone: "+33 1 60 13 37 83",
  phoneDisplay: "+33 1 60 13 37 83",
  phoneLink: "tel:+33160133783",
  mapEmbed: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2632.5!2d2.246!3d48.715!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDjCsDQyJzUzLjQiTiAywrAxNCc0NS42IkU!5e0!3m2!1sfr!2sfr!4v1234567890",
  payments: ["Espèces", "CB", "Tickets resto"],
  badges: ["Halal"],
  openingHours: {
    lundi: "Fermé",
    mardi: "11:00–15:00, 18:00–23:00",
    mercredi: "11:00–15:00, 18:00–23:00",
    jeudi: "11:00–15:00, 18:00–23:00",
    vendredi: "11:00–23:00",
    samedi: "11:00–23:00",
    dimanche: "11:00–23:00"
  }
};

export const aboutText = {
  title: "À propos de L'Original",
  cards: [
    {
      title: "Ingrédients frais",
      description: "Nos recettes sont préparées chaque jour avec des ingrédients frais, sélectionnés avec soin pour garantir goût et qualité.",
      icon: "chef"
    },
    {
      title: "Viandes halal",
      description: "Toutes nos viandes sont halal, pour vous offrir une expérience en toute confiance et en toute sérénité.",
      icon: "halal"
    },
    {
      title: "Depuis 2019 à Palaiseau",
      description: "Installés à Palaiseau depuis 2019, nous vous régalons avec passion et savoir-faire, sur place ou à emporter.",
      icon: "location"
    }
  ]
};

export const galleryImages = [
  {
    id: 1,
    url: "https://customer-assets.emergentagent.com/job_de8caf30-ad26-453f-82ca-9c7194fae09f/artifacts/hdcctx7j_ChatGPT%20Image%2013%20d%C3%A9c.%202025%2C%2017_40_11.png",
    alt: "Burger L'Original",
    category: "Burgers"
  },
  {
    id: 2,
    url: "https://customer-assets.emergentagent.com/job_de8caf30-ad26-453f-82ca-9c7194fae09f/artifacts/ern5dvhu_ChatGPT%20Image%2013%20d%C3%A9c.%202025%2C%2017_58_40.png",
    alt: "Pizza L'Original",
    category: "Pizza"
  },
  {
    id: 3,
    url: "https://customer-assets.emergentagent.com/job_de8caf30-ad26-453f-82ca-9c7194fae09f/artifacts/4qw3a3zk_ChatGPT%20Image%2013%20d%C3%A9c.%202025%2C%2018_00_56.png",
    alt: "Sandwich L'Original",
    category: "Sandwich"
  },
  {
    id: 4,
    url: "https://customer-assets.emergentagent.com/job_de8caf30-ad26-453f-82ca-9c7194fae09f/artifacts/cb5j62ds_ChatGPT%20Image%2013%20d%C3%A9c.%202025%2C%2018_30_43.png",
    alt: "Tex-Mex L'Original",
    category: "Tex-Mex"
  },
  {
    id: 5,
    url: "https://customer-assets.emergentagent.com/job_de8caf30-ad26-453f-82ca-9c7194fae09f/artifacts/2791dwqu_ChatGPT%20Image%2013%20d%C3%A9c.%202025%2C%2018_19_14.png",
    alt: "Nos plats L'Original",
    category: "Autres"
  },
  {
    id: 6,
    url: "https://images.unsplash.com/photo-1630384060421-cb20d0e0649d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwxfHxmcmllc3xlbnwwfHx8fDE3NjI4NzcxMDB8MA&ixlib=rb-4.1.0&q=85",
    alt: "Frites croustillantes",
    category: "Frites"
  }
];

export const menuData = {
  pizzas: {
    title: "Pizzas",
    offers: {
      title: "🎉 OFFRES PIZZAS (seulement à emporter)",
      items: [
        "2 pizzas achetées = la 3ᵉ offerte",
        "1 pizza achetée = la 2ᵉ à -50 %"
      ]
    },
    categories: [
      {
        subtitle: "🍕 Margherita",
        items: [
          { name: "Margherita", description: "Tomate, mozzarella", price: "10,50€", special: true }
        ]
      },
      {
        subtitle: "🍕 Pizzas Sauce Tomate – 14,00€",
        items: [
          { name: "Paysanne", description: "Tomate, mozzarella, lardons, oignons rouges, œuf", price: "14,00€" },
          { name: "Reine", description: "Tomate, mozzarella, jambon de dinde, champignons", price: "14,00€" },
          { name: "Orientale", description: "Tomate, mozzarella, oignons, merguez de bœuf, poivrons, œuf", price: "14,00€" },
          { name: "Soufflée", description: "Tomate, mozzarella, 1 viande au choix (viande hachée / jambon de dinde / poulet), œuf", price: "14,00€" },
          { name: "Neptune", description: "Tomate, mozzarella, thon, oignons, olives, œuf", price: "14,00€" }
        ]
      },
      {
        subtitle: "🍕 Pizzas Sauce Tomate – 16,00€",
        items: [
          { name: "4 Saisons", description: "Tomate, mozzarella, jambon de dinde, champignons, olives, artichauts", price: "16,00€" },
          { name: "L'Originale Pizza", description: "Tomate, mozzarella, viande hachée, merguez, poivrons, oignons, œuf", price: "16,00€", featured: true },
          { name: "4 Fromages", description: "Tomate, mozzarella, gorgonzola, crottin de chèvre, parmesan", price: "16,00€" },
          { name: "Charcutière", description: "Tomate, mozzarella, jambon de dinde, lardons de veau, bacon de bœuf américain, œuf, mesclun", price: "16,00€" },
          { name: "Fermière", description: "Tomate, mozzarella, émincé de poulet, champignons, œuf, chèvre", price: "16,00€" },
          { name: "Mexicaine", description: "Tomate, mozzarella, merguez, chorizo, oignons, poivrons", price: "16,00€" },
          { name: "Mousaka", description: "Tomate, mozzarella, viande hachée, aubergines, crème fraîche", price: "16,00€" }
        ]
      },
      {
        subtitle: "🍕 Sauce Tomate sans Mozzarella – 16,00€",
        items: [
          { name: "Gorgonzola", description: "Tomate, champignons, jambon de dinde, gorgonzola, œuf", price: "16,00€" },
          { name: "Chèvre", description: "Tomate, chèvre, jambon de dinde, oignons, poivrons", price: "16,00€" },
          { name: "Végétarienne", description: "Tomate, champignons, aubergines grillées, olives, oignons, poivrons, artichauts", price: "16,00€" }
        ]
      },
      {
        subtitle: "🍕 Crème Fraîche – 16,00€",
        items: [
          { name: "Pacifico", description: "Crème fraîche, mozzarella, saumon, œuf, citron, mesclun", price: "16,00€" },
          { name: "Chèvre Miel", description: "Crème fraîche, mozzarella, crottin de chèvre, chèvre, miel", price: "16,00€" },
          { name: "Chicken", description: "Crème fraîche, mozzarella, émincé de poulet, pommes de terre, oignons, œuf", price: "16,00€" },
          { name: "Raclette", description: "Crème fraîche, mozzarella, lardons de veau, pommes de terre, oignons, raclette", price: "16,00€" }
        ]
      },
      {
        subtitle: "🍕 Spéciales Chef – 17,00€",
        items: [
          { name: "Spéciales Chef", description: "Toutes les pizzas \"Spéciales Chef\"", price: "17,00€", featured: true },
          { name: "Burrata", description: "Tomates confites, mozzarella, bacon de bœuf, burrata, pesto, mesclun", price: "17,00€" }
        ]
      }
    ]
  },
  sandwiches: {
    title: "Sandwichs",
    subtitle: "Servis avec frites",
    note: "Boisson 33 cl : +1,50€ | Choix du pain : baguette ou pain maison",
    items: [
      { name: "L'Américain", description: "Salade, tomate, oignons, steak 150 g, cheddar, œuf", price: "9,00€" },
      { name: "Le Poulet", description: "Salade, tomate, oignons, escalope de poulet, cheddar, œuf", price: "9,00€" },
      { name: "Le Kebab Artisanal Maison", description: "Salade, tomates, oignons, kebab maison", price: "8,50€" },
      { name: "Le Cordon", description: "Salade, tomate, oignons, cordon bleu, cheddar, œuf", price: "8,50€" },
      { name: "Le Poulet Spécial du Chef", description: "Salade, tomates, oignons, escalope de poulet, boursin, œuf, emmental", price: "11,00€", featured: true },
      { name: "L'Original Veggie", description: "Œuf coulant, avocat crémeux, chèvre chaud, touche de miel, mesclun", price: "9,00€" },
      { name: "Foie de veau", description: "Salade, tomate, oignons rouges, œuf, foie de veau", price: "13,00€" },
      { name: "Le Kebab Miel", description: "Salade, tomates, oignons rouges, œuf, kebab au miel, emmental", price: "10,00€" },
      { name: "Le Mixte", description: "2 viandes au choix, salade, tomates, oignons rouges, cheddar, œuf", price: "13,00€" }
    ],
    supplements: {
      title: "Suppléments sandwichs",
      items: [
        { name: "+1,50€", description: "Cheddar, miel, œuf, oignons caramélisés, avocat" },
        { name: "+2,00€", description: "Bacon de bœuf, jambon de dinde, lardon de veau" },
        { name: "+4,50€", description: "Steak haché façon bouchère 150 g, cordon bleu, kebab, escalope de poulet" }
      ]
    }
  },
  texMex: {
    title: "Tex-Mex",
    menu: {
      name: "Menu Tex-Mex",
      description: "Frites + boisson",
      choices: [
        "8 nuggets",
        "5 wings",
        "6 tenders"
      ],
      price: "9,00€"
    },
    manchons: {
      title: "Wings",
      items: [
        { quantity: "1 pièce", price: "1,50€" },
        { quantity: "6 pièces", price: "8,00€" },
        { quantity: "12 pièces", price: "16,00€" },
        { quantity: "18 pièces", price: "25,00€" }
      ]
    },
    tenders: {
      title: "Tenders",
      items: [
        { quantity: "1 pièce", price: "1,20€" },
        { quantity: "7 pièces", price: "7,00€" },
        { quantity: "14 pièces", price: "14,00€" },
        { quantity: "21 pièces", price: "21,00€" }
      ]
    },
    autres: {
      title: "Tenders Tempura ou Donuts",
      items: [
        { quantity: "1 pièce", price: "2,50€" },
        { quantity: "6 pièces", price: "14,00€" },
        { quantity: "12 pièces", price: "27,00€" },
        { quantity: "18 pièces", price: "40,00€" }
      ]
    }
  },
  burgers: {
    title: "Burgers",
    classic: {
      subtitle: "Burgers Classiques",
      note: "Menu (frites + boisson 33 cl) : +3,50€",
      items: [
        { name: "Cheese Burger", description: "Sauce maison, oignons rouges, steak, cheddar", soloPrice: "3,50€", menuPrice: "7,00€" },
        { name: "Double Cheese", description: "Sauce maison, oignons rouges, 2 steaks, cheddar", soloPrice: "4,50€", menuPrice: "8,00€" },
        { name: "Triple Cheese", description: "Sauce maison, oignons rouges, 3 steaks, cheddar", soloPrice: "5,50€", menuPrice: "9,00€" },
        { name: "Filet", description: "Sauce fish, filet pané, cheddar", soloPrice: "4,50€", menuPrice: "8,00€" },
        { name: "Double Filet", description: "Sauce fish, double filet pané, cheddar", soloPrice: "8,00€", menuPrice: "11,50€" },
        { name: "Escalope", description: "Sauce maison, salade, tomate, oignons rouges, escalope, cheddar", soloPrice: "5,00€", menuPrice: "8,50€" },
        { name: "Mixte", description: "Sauce maison, salade, tomate, oignons rouges, steak, escalope, cheddar", soloPrice: "6,00€", menuPrice: "9,50€" },
        { name: "Double Cheese Egg", description: "Sauce maison, oignons rouges, 2 steaks, cheddar, œuf", soloPrice: "5,50€", menuPrice: "9,00€" }
      ]
    },
    maison: {
      subtitle: "Burgers Maison",
      note: "Servis avec frites + boisson 33 cl",
      items: [
        { name: "L'Original", description: "Salade, tomates, oignons rouges, steak 150 g, bacon de bœuf, cheddar", price: "13,00€", featured: true },
        { name: "Le BBQ", description: "Salade, tomates, oignons rouges, steak 150 g, bacon de bœuf, œuf, cheddar", price: "14,00€" },
        { name: "Le Big Burger", description: "Salade, tomate, oignons rouges, steak 150 g, galette de poulet pané, œuf", price: "15,00€" },
        { name: "Le Vegan", description: "Salade, tomate, oignons rouges, steak de légumes, galette de pommes de terre, champignon portobello", price: "15,00€" },
        { name: "Le Savoureux", description: "Salade, tomate, oignons rouges, steak 150 g, avocat, gorgonzola", price: "14,00€" },
        { name: "Le Classic Gourmet", description: "Salade, tomate, oignons rouges, steak 150 g, cheddar", price: "11,00€" },
        { name: "Le Savoyard", description: "Salade, tomate, oignons rouges, steak 150 g, raclette, jambon de dinde, galette de pommes de terre", price: "15,00€" },
        { name: "L'Italia", description: "Salade, tomates, oignons rouges, steak 150 g, burrata, pesto", price: "14,00€" },
        { name: "Le Parisien", description: "Salade, tomate, oignons rouges, steak 150 g, jambon de dinde, emmental fondu", price: "13,00€" },
        { name: "Le Chèvre", description: "Salade, tomates, oignons rouges, steak 150 g, chèvre", price: "13,00€" },
        { name: "Le Chèvre Miel", description: "Salade, tomates, oignons rouges, steak 150 g, pesto, chèvre, miel", price: "14,00€" }
      ]
    }
  },
  panuozzo: {
    title: "Panuozzo",
    note: "+3,50€ — Frites + boisson 33 cl",
    items: [
      { name: "Burrata", description: "Huile d'olive, mozzarella fior di latte, bacon de bœuf américain, jeunes pousses, oignons rouges, tomates cerises, burrata, pesto", price: "9,00€" },
      { name: "Poulet Curry", description: "Huile d'olive, mozzarella fior di latte, poulet curry, jeunes pousses, oignons rouges, tomates confites, cheddar", price: "8,00€" },
      { name: "Kebab", description: "Huile d'olive, mozzarella fior di latte, jeunes pousses, oignons rouges, tomates confites, kebab maison, cheddar", price: "8,00€" },
      { name: "Steak Façon Bouchère", description: "Huile d'olive, mozzarella fior di latte, steak façon bouchère, cheddar, jeunes pousses, oignons caramélisés, tomates confites", price: "10,00€" },
      { name: "Panuozzo Signature", description: "Huile d'olive, mozzarella fior di latte, jeunes pousses, oignons rouges, jambon de bœuf, jambon de veau, stracciatella, crème de balsamique", price: "12,00€", featured: true },
      { name: "Panuozzo Norvégien", description: "Huile d'olive, mozzarella fior di latte, jeunes pousses, oignons rouges, saumon fumé, touche de miel", price: "10,00€" }
    ]
  },
  salades: {
    title: "Nos Salades",
    items: [
      { name: "La Fermière", description: "Jeunes pousses, laitue, oignons rouges, maïs, tomates cerises, escalope de poulet mariné, dés d'emmental", price: "9,90€" },
      { name: "La Burratina", description: "Jeunes pousses, laitue, oignons rouges, tomates confites, burrata, pesto, crème de balsamique", price: "10,50€" },
      { name: "La Chèvre Miel", description: "Jeunes pousses, laitue, oignons rouges, tomates cerises, avocat, chèvre chaud, noix, croûtons croustillants, touche de miel", price: "10,50€" }
    ]
  },
  sides: {
    title: "Accompagnements",
    frites: [
      { size: "Petite", price: "3,50€" },
      { size: "Moyenne", price: "4,50€" },
      { size: "Grande", price: "6,50€" }
    ],
    drinks: [
      { size: "33 cl", price: "1,50€" }
    ]
  },
  desserts: {
    title: "Desserts",
    items: [
      { name: "Tiramisu", price: "4,00€" },
      { name: "Tarte Daim", price: "3,50€" },
      { name: "Cheesecake fruits rouges", price: "4,00€" },
      { name: "Häagen-Dazs 100 ml", price: "4,00€" }
    ]
  }
};
